import { useEffect, useRef, useState } from "react"
import { fetchQuery, graphql } from 'relay-runtime'
import Env from '@src/RelayEnvironment'
import { getCategoriesForFilter } from "../SearchV2/Search.utils"
import type { Game } from '@src/components/Game/Game.types'
import { NormalizedGameOrder, ThumbnailSliderNormalizedGamesQuery } from "./__generated__/ThumbnailSliderNormalizedGamesQuery.graphql"

export const useGameSearchLite = (
  shouldFetch: boolean, 
  selectedProviders: string[] = [], 
  selectedCategory: string | null = null,
  orderBy: NormalizedGameOrder = 'POPULAR',
  pageSize: number = 15
) => {
    const [games, setGames] = useState<Game[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const hasFetchedRef = useRef(false)
  
    useEffect(() => {
      if (!shouldFetch || hasFetchedRef.current) return
  
      setIsLoading(true)
      // Only get categories if selectedCategory is not 'popular'
      const categories = selectedCategory !== 'popular' ? getCategoriesForFilter(selectedCategory) : undefined
  
      fetchQuery<ThumbnailSliderNormalizedGamesQuery>(
        Env,
        listNormalizedGames,
        {
          page: 1,
          pageSize,
          filter: {
            aggregator: ['HUB88', 'ENDORPHINA', 'BJFUN'],
            ...(categories && { categories }),
            ...(selectedProviders.length > 0 && { providers: selectedProviders }),
          },
          orderBy,
        },
        { fetchPolicy: 'network-only' }
      ).subscribe({
        next: (data) => {
          const { listNormalizedGames } = data
          setGames([...listNormalizedGames.entries])
          setIsLoading(false)
          hasFetchedRef.current = true
        },
        error: (err) => {
          console.error('Error fetching games:', err)
          setIsLoading(false)
        },
        complete: () => {
          setIsLoading(false)
        },
      })
    }, [shouldFetch])
  
    return { games, isLoading }
  }

const listNormalizedGames = graphql`
  query ThumbnailSliderNormalizedGamesQuery(
    $filter: ListNormalizedGamesFilter!, 
    $page: Int!, 
    $pageSize: Int,
    $orderBy: NormalizedGameOrder
  ) {
    listNormalizedGames(
      filter: $filter, 
      page: $page, 
      pageSize: $pageSize,
      orderBy: $orderBy
    ) {
      entries {
        urlThumb
        aggregator
        gameId
        category
        provider
        label
        customThumb
      }
    }
  }
`